import React, { useState, useEffect } from "react";
import "./LegalIdentity.css";
import {
  FaCertificate,
  FaBalanceScale,
  FaIdCard,
  FaFileAlt,
} from "react-icons/fa";
import Foot from "../Navbar-footer/Foot";
import Nav from "../Navbar-footer/Nav";

const documents = [
  {
  id: "doc1",
  title: "NGO Registration Certificate",
  description:
    "Registered and certified under the Societies Registration Act, confirming our legal existence and adherence to statutory regulations. This certificate establishes our credibility, enabling us to operate transparently, secure funding, and build partnerships while complying with all government norms.",
  image: "/assets/bloodlogo.png",
  icon: <FaCertificate />,
},
{
  id: "doc2",
  title: "17A / 11AA / 2C Registration",
  description:
    "Registration under Sections 17A, 11AA, and 2C of the Income Tax Act grants us recognition as a legitimate charitable organization. This ensures that our income remains tax-exempt, validates our eligibility for government benefits, and reinforces our commitment to non-profit operations.",
  image: "/assets/bloodlogo.png",
  icon: <FaBalanceScale />,
},
{
  id: "doc3",
  title: "PAN Card",
  description:
    "Our official Permanent Account Number (PAN) issued by the Income Tax Department serves as our primary financial identity. It ensures our compliance with taxation regulations, enables secure banking operations, and reinforces our accountability in all financial matters.",
  image: "/assets/bloodlogo.png",
  icon: <FaIdCard />,
},
{
  id: "doc4",
  title: "CSR-1 Certificate",
  description:
    "The CSR-1 registration authorizes us to receive Corporate Social Responsibility (CSR) funds from companies. This certification ensures we meet all compliance standards for utilizing CSR contributions effectively, boosting our capacity to expand community welfare projects.",
  image: "/assets/bloodlogo.png",
  icon: <FaFileAlt />,
},

];

const LegalIdentity = () => {
  const [showDocuments, setShowDocuments] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState(null);

  useEffect(() => {
    const timer = setTimeout(() => setShowDocuments(true), 1500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
    <Nav />
    <div id="legal-section">
      <div className="overlay">
        <div className="legal-header fade-in">
          <h2 className="legal-title">About Our Legality</h2>
          <p className="legal-paragraph">
            We are a fully government-registered non-profit organization dedicated to social welfare and transparency. Our operations are compliant with the Indian legal system, ensuring accountability in every initiative.
          </p>
          <p className="legal-paragraph">
            With valid registration and tax exemption documents, we guarantee our donors, partners, and volunteers full legal assurance. Our certifications are a testament to our commitment, values, and the trust we’ve built with communities and institutions.
          </p>
        </div>

        {showDocuments && (
          <div className="document-selector fade-in">
            {documents.map((doc) => (
              <div
                key={doc.id}
                className={`doc-card ${selectedDoc?.id === doc.id ? "active" : ""}`}
                onClick={() => setSelectedDoc(doc)}
              >
                <div className="icon">{doc.icon}</div>
                <span className="doc-title">{doc.title}</span>
              </div>
            ))}
          </div>
        )}

        {selectedDoc && (
          <div className="popup fade-in">
            <div className="popup-content">
              <button className="close-btn" onClick={() => setSelectedDoc(null)}>
                &times;
              </button>
              <h3 className="doc-popup-title">{selectedDoc.title}</h3>
              <p className="doc-popup-description">{selectedDoc.description}</p>
              <img src={selectedDoc.image} alt={selectedDoc.title} className="doc-image" />
            </div>
          </div>
        )}
      </div>
    </div>
    <Foot/>
    </>
  );
};

export default LegalIdentity;
